module.exports = __webpack_public_path__ + "static/img/Libra.c8f91e1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/zodiac_image/Libra.svg
// module id = 1400
// module chunks = 0